import React, { useState } from 'react';
import { Observer } from 'mobx-react';
import { Button, TextField, InputAdornment } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import { toJS } from 'mobx';
import * as Yup from 'yup';
import { useRootStore } from '../../../stores/BridgeProvider';
import { StyledForm } from '../../styles/styles';
import { MenuList, filterOptions } from '../../util/ReactSelectOverrides';
import { safeEval } from '../../util/UtilFunctions';
import RenderPropModal from '../../dealMapper/common/RenderPropModal';
import MappedPaymentsDisplay from './MappedPaymentsDisplay';
import { CustomSelect } from '../../util/CustomCreatableSelect';

const ApplyPayment = ({
  voucher,
  paymentVouchers,
  fetchPaymentVouchers,
  fetchVoucher,
}) => {
  const [selectedPayment, setSelectedPayment] = useState(null);
  const history = useHistory();
  const { authStore, dataStore } = useRootStore();
  const { Amount, VoucherId } = voucher;

  const formatAmount = num => parseFloat(num).toFixed(2);
  const balanceDue = voucher.Amount - voucher.AmountPaid;
  const formattedBalance = formatAmount(balanceDue);

  const initialValues = {
    payment: null,
    paymentId: null,
    amount: formattedBalance || 0,
  };
  const payLimit = () => {
    if (selectedPayment !== null) {
      return selectedPayment.Amount < balanceDue
        ? selectedPayment.Amount
        : balanceDue;
    }
    return balanceDue;
  };

  const maxnum = payLimit();
  const PaymentSchema = Yup.object().shape({
    payment: Yup.object({
      PaymentId: Yup.number(),
    }),
    amount: Yup.number()
      .min(0)
      .max(maxnum),
  });
  return (
    <Observer
      render={() => {
        const payments = dataStore.paymentArray;
        return (
          <RenderPropModal
            containerStyle={{ width: '100%' }}
            cardDisplay={({ handleClose }) => (
              <Formik
                initialValues={initialValues}
                validationSchema={PaymentSchema}
                onSubmit={async (values, actions) => {
                  try {
                    await authStore.request.post(
                      `${process.env.REACT_APP_API}/api/payment-voucher/`,
                      {
                        voucherId: VoucherId,
                        paymentId: values.paymentId,
                        amount: values.amount,
                      },
                    );
                    fetchPaymentVouchers();
                    fetchVoucher();
                    handleClose();
                    history.push(`/vouchers/${VoucherId}`);
                  } catch (e) {
                    console.error(e);
                    actions.setSubmitting(false);
                  }
                }}
                render={({
                  handleBlur,
                  handleChange,
                  setFieldValue,
                  errors,
                  handleSubmit,
                  values,
                  touched,
                  isSubmitting,
                  resetForm,
                }) => {
                  const showError = val => errors[val] && touched[val];

                  return (
                    <StyledForm
                      onSubmit={handleSubmit}
                      style={{ width: '100%' }}
                    >
                      <div style={{ width: '100%', zIndex: 1000 }}>
                        <CustomSelect
                          isSearchable
                          isClearable
                          placeholder="Payments"
                          components={{ MenuList }}
                          options={payments.filter(payment =>
                            paymentVouchers.every(pi => {
                              return pi.PaymentId !== payment.PaymentId;
                            }),
                          )}
                          getOptionLabel={({ ContactName, AccountName }) =>
                            `${ContactName} - ${AccountName}`
                          }
                          getOptionValue={option => option.PaymentId}
                          value={values.payment}
                          filterOption={filterOptions}
                          error={showError('payment')}
                          onChange={val => {
                            console.log(toJS(val));
                            setSelectedPayment(val);
                            setFieldValue('payment', val);
                            setFieldValue(
                              'paymentId',
                              safeEval(() => val.PaymentId),
                              null,
                            );
                            setFieldValue(
                              'amount',
                              formatAmount(
                                val.Amount > maxnum ? maxnum : val.Amount,
                              ),
                            );
                          }}
                        />
                      </div>
                      <TextField
                        // FIXME: MAKE THIS WORK WITH PAYMENT AMOUNT
                        name="amount"
                        label="Amount"
                        value={values.amount}
                        // max={JSON.stringify(Amount)}
                        margin="normal"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="outlined"
                        fullWidth
                        error={showError('amount')}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                      />
                      <div
                        css={css`
                          display: flex;
                          margin-top: 1.2rem;
                          justify-content: center;
                          & > button,
                          a {
                            margin: 5px;
                          }
                        `}
                      >
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          size="large"
                          disabled={isSubmitting || !values.payment}
                        >
                          Submit
                        </Button>
                        <Button
                          color="secondary"
                          variant="outlined"
                          size="large"
                          onClick={() => {
                            resetForm(initialValues);
                            handleClose();
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </StyledForm>
                  );
                }}
              />
            )}
          >
            {({ handleOpen }) => (
              <MappedPaymentsDisplay
                paymentVouchers={paymentVouchers}
                fetchPaymentVouchers={fetchPaymentVouchers}
                fetchVoucher={fetchVoucher}
                mapPayment={handleOpen}
                voucher={voucher}
              />
            )}
          </RenderPropModal>
        );
      }}
    />
  );
};

export default ApplyPayment;
